// Shared language registry — add new languages here and they flow through the editor + reader.
export const LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "bn", name: "Bengali", native: "বাংলা" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "ta", name: "Tamil", native: "தமிழ்" },
  { code: "te", name: "Telugu", native: "తెలుగు" },
  { code: "mr", name: "Marathi", native: "मराठी" },
  { code: "gu", name: "Gujarati", native: "ગુજરાતી" },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ" },
  { code: "ml", name: "Malayalam", native: "മലയാളം" },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ" },
  { code: "ur", name: "Urdu", native: "اردو" },
];

export const DEFAULT_LANGUAGES = ["en", "bn"];

export const CATEGORIES = [
  { code: "trek-and-travel", name: "Trek & Travel" },
  { code: "others", name: "Others" },
];

export const langByCode = (code) =>
  LANGUAGES.find((l) => l.code === code) || { code, name: code, native: code };

export const wordCount = (text) =>
  (text || "").trim().split(/\s+/).filter((w) => w.length > 0).length;

export const getYouTubeId = (urlOrId) => {
  if (!urlOrId) return "";
  if (/^[a-zA-Z0-9_-]{11}$/.test(urlOrId)) return urlOrId;
  const m = urlOrId.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([a-zA-Z0-9_-]{11})/
  );
  return m ? m[1] : urlOrId;
};

export const renderStoryParagraphs = (text) => {
  if (!text) return [];
  return text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
};
